import React, { useContext, useEffect, useState, useMemo } from 'react';
import Swal from 'sweetalert2';

import tenantsContext from '../../context/tenants/tenantsContext';
import AddItm from '../../components/addItm/AddItm';
import SearchInput from '../../components/searchInput/SearchInput';
import TenantRow from '../../components/tenantRow/TenantRow';
import TenantForm from '../../components/tenantForm/TenantForm';

import './Tenants.css';

function Tenants() {
    const tContext = useContext(tenantsContext);
    const { tenants, getAllTenants, addTenant, updateTenant, deleteTenant } = tContext;

    const [filter, setFilter] = useState('');
    const [openForm, setOpenForm] = useState(false);
    const [currentTenant, setCurrentTenant] = useState(null);

    useEffect(() => {
        getAllTenants();
    }, []);

    const handleOpenForm = (tenant = null) => {
        setCurrentTenant(tenant);
        setOpenForm(true);
    };

    const handleCloseForm = () => {
        setOpenForm(false);
        setCurrentTenant(null);
    };

    const handleSave = async (tenantData) => {
        try {
            if (tenantData._id) {
                await updateTenant(tenantData);
                Swal.fire('Éxito', 'Tenant actualizado correctamente', 'success');
            } else {
                await addTenant(tenantData);
                Swal.fire('Éxito', 'Tenant creado correctamente', 'success');
            }
            handleCloseForm();
            await getAllTenants();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al guardar tenant', 'error');
        }
    };

    const handleDelete = async (tenant) => {
        try {
            await deleteTenant(tenant);
            Swal.fire('Eliminado', 'Tenant eliminado correctamente', 'success');
            await getAllTenants();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al eliminar tenant', 'error');
        }
    };

    const handleSearchInput = (value) => {
        setFilter(value);
    };

    const tenantsFiltered = useMemo(() => {
        if (!tenants) return [];
        return tenants.filter(t => {
            if (filter === '') return true;
            const filterLower = filter.toLowerCase();
            return (
                t.codTenant?.toLowerCase().includes(filterLower) ||
                t.name?.toLowerCase().includes(filterLower)
            );
        });
    }, [tenants, filter]);

    if (tenants === null) {
        return <h3 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h3>;
    }

    return (
        <div className="tenantsList">
            <AddItm titulo={'Tenant'} anadiritm={handleOpenForm} />
            <SearchInput buscar={handleSearchInput} filter={filter} />

            {tenantsFiltered.length === 0 ? (
                <h3 className="warningStatusMsg">No hay tenants cargados</h3>
            ) : (
                tenantsFiltered.map((tenant) => (
                    <TenantRow
                        key={tenant._id}
                        tenant={tenant}
                        onEdit={handleOpenForm}
                        onDelete={handleDelete}
                    />
                ))
            )}

            <TenantForm
                open={openForm}
                onClose={handleCloseForm}
                tenant={currentTenant}
                onSave={handleSave}
            />
        </div>
    );
}

export default Tenants;
